import { getCurrentAuthToken } from '../api/client'

let userProvider: () => string | null = () => null

export function setRequestUserProvider(provider: () => string | null) {
  userProvider = provider
}

export class AuthSessionChangedError extends Error {
  constructor() {
    super('Учётная запись изменилась. Откройте задание под своей учётной записью.')
    this.name = 'AuthSessionChangedError'
  }
}

/** Capture credentials before IndexedDB/network awaits so an old callback cannot use a new user's token. */
export function captureRequestSession(ownerUserId: string) {
  const userId = userProvider()
  const token = getCurrentAuthToken()
  if (userId !== null && userId !== ownerUserId) throw new AuthSessionChangedError()
  const sameUser = () => userProvider() === userId
  return {
    token,
    authRequired: userId !== null && token === null,
    sameUser,
    reauthenticated: () => sameUser() && getCurrentAuthToken() !== null && getCurrentAuthToken() !== token,
    assertSameUser() {
      if (!sameUser()) throw new AuthSessionChangedError()
    },
    assertCurrent() {
      if (!sameUser() || getCurrentAuthToken() !== token) throw new AuthSessionChangedError()
    },
  }
}
